import { render, staticRenderFns } from "./loadingButton.vue?vue&type=template&id=32615748&scoped=true"
import script from "./loadingButton.vue?vue&type=script&lang=js"
export * from "./loadingButton.vue?vue&type=script&lang=js"
import style0 from "./loadingButton.vue?vue&type=style&index=0&id=32615748&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32615748",
  null
  
)

export default component.exports